import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {FaFilter ,IoSearchSharp ,MdOutlineCancel ,BiReset} from "../../utils/icons"
import { DLabel, DSpinButton, Select } from '../../utils/Form'
function CaseFilter({ 
    caseNumber,
    setCaseNumber,
    clientName,
    setClientName,
    opponentName,
    setOpponentName,
    caseType,
    setCaseType,
    courtType,
    setCourtType,
    courtName,
    setCourtName,
    nextSessionDate

    ,setNextSessionDate
    
}) {
    const { t } = useTranslation()
    const [open ,setOpen]=useState(false)

    const [fcaseNumber,setFcaseNumber]=useState(  "")
    const [fclientName,setFclientName]=useState( "")
    const [fopponentName,setFopponentName]=useState(  "")
    const [fcaseType,setFcaseType]=useState( "")
    const [fcourtType,setFcourtType]=useState(  "")
    const [fcourtName,setFcourtName]=useState(  "")
    const [fnextSessionDate,setFnextSessionDate]=useState( "")
 




    const handeleSearsh =() =>{
if (caseNumber != null) {
    setCaseNumber(fcaseNumber)
    }

if (clientName != null) {
    setClientName(fclientName)
    }
if (opponentName != null) {
    setOpponentName(fopponentName)
    }
if (caseType != null) {
    setCaseType(fcaseType)
    }
if (courtType != null) {
    setCourtType(fcourtType)
    }
if (courtName != null) {
    setCourtName(fcourtName)
    }
if (nextSessionDate != null) {
    setNextSessionDate(fnextSessionDate)
    }
}


 const handelReset =() =>{
    if (caseNumber != null) {
        setCaseNumber("")
        }
    if (clientName != null) {
        setClientName("")
        }
    if (opponentName != null) {
        setOpponentName("")
        }
    if (caseType != null) {
        setCaseType("")
        }
    if (courtType != null) {
        setCourtType("")
        }
    if (courtName != null) {
        setCourtName("")
        }
    if (nextSessionDate != null) {
        setNextSessionDate("")
        }
    if (fcaseNumber != null) {
        setFcaseNumber("")
        }
        
    }
  return (
    <div className='flex  items-center relative flex-col ' >
        <button className=' border bg-n-1 dark:bg-back-darktertiary border-color-1 dark:border-tcolor-2 px-5 py-1 flex flex-row items-center justify-center gap-3 rounded-lg'
        onClick={()=>setOpen(true)}
        >

              <h2 className='h5 dark:text-tcolor-2  text-color-1'>{t("Filter")}</h2>
        <FaFilter size={25} className='text-color-1 dark:text-tcolor-2' /></button>
{
   open &&    
    (<div className="nav-item   absolute border border-gray-200  top-16 bg-white p-8 rounded-lg w-80">
        <button className='p-2 rounded-full text-color-1 my-4 bg-n-1 hover:bg-n-2'
        onClick={()=>setOpen(false)}
        >
<MdOutlineCancel  size={25}/>
        </button>
{ caseNumber !== null  &&
    <DLabel
    labelText="case Number"
    value={fcaseNumber}
    onChange={(e)=> {setFcaseNumber(e.target.value)}}
    required={true}
    type="text"
    name="caseNumber"
    />
}
{
    nextSessionDate != null  &&
    <DLabel
    labelText="next Session Date"
    value={fnextSessionDate}
    onChange={(e)=> {setFnextSessionDate(e.target.value)}}
    required={true}
    type="date"
    name="nextSessionDate"
    />
}
{
    clientName != null  &&
    <DLabel
    labelText="client Name"
    value={fclientName}
    onChange={(e)=> {setFclientName(e.target.value)}}
    required={true}
    type="text"
    name="clientName"
    />
}
{
    opponentName != null  &&
    <DLabel
    labelText="opponent Name"
    value={fopponentName}
    onChange={(e)=> {setFopponentName(e.target.value)}}
    required={true}
    type="text"
    name="opponentName"
    />
}

{
    caseType != null  &&
    <DLabel
    labelText="case Type"
    value={fcaseType}
    onChange={(e)=> {setFcaseType(e.target.value)}}
    required={true}
    type="text"
    name="caseType"
    />
}
{
    courtType != null  &&
    <DLabel
    labelText="court Type"
    value={fcourtType}
    onChange={(e)=> {setFcourtType(e.target.value)}}
    required={true}
    type="text"
    name="courtType"
    />
}
{
    courtName != null  &&
    <DLabel
    labelText="court Name"
    value={fcourtName}
    onChange={(e)=> {setFcourtName(e.target.value)}}
    required={true}
    type="text"
    name="courtName"
    />
}

 


<div className=" flex flex-row gap-3 py-4 border-t-2 border-gray-200 justify-center items-center">  <DSpinButton 
     onClick={handeleSearsh}
       bgColor={"text-white   bg-gradient-to-r from-blue-600 via-blue-700 to-blue-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300  shadow-lg shadow-blue-600/50 "}
       borderColor={"border-none"}
       fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Search")}
     <IoSearchSharp size={22} className='text-white' /></span> 
     </DSpinButton>
      
      <DSpinButton 
     onClick={handelReset}
     bgColor={"text-white  bg-gradient-to-r from-red-600 via-red-700 to-red-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-red-300  shadow-lg shadow-red-600/50 "}
     borderColor={"border-none"}
     fillColor={"fill-n-1"}
     > <span className='flex flex-row gap-2'>{t("Reset")}
     <BiReset size={22} className='text-white ' /></span> </DSpinButton>
      </div>
   
    </div>)
}

     
      
    </div>
  )
}

export default CaseFilter